import React from 'react'
import { FlatList } from 'react-native'
import { SavedNotes } from '../noteTypes'
import { SavedItems } from '../SavedItems'

type PropTypes = {
  notes: SavedNotes[] | string[]
  setVisible: (a: boolean) => void
  setItemToDelete: (a: string) => void
  isItInvoiceCreate?: boolean
}
export const NotesList = (props: PropTypes) => {
  const { notes, setVisible, setItemToDelete, isItInvoiceCreate } = props
  if (!notes.length) return null
  return (
    <FlatList
      data={notes as any}
      renderItem={({ item }) => (
        <SavedItems
          item={item}
          setVisible={setVisible}
          setItemToDelete={setItemToDelete}
          isItInvoiceCreate={isItInvoiceCreate}
        />
      )}
      keyExtractor={(item, id) => id.toString()}
    />
  )
}
